function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:#fefddb;}.cls-3{fill:#fff;}.cls-10,.cls-3{stroke:#c2c2c2;stroke-miterlimit:10;stroke-width:3px;}.cls-11,.cls-4{fill:#8ce08c;}.cls-10,.cls-5,.cls-6,.cls-8,.cls-9{fill:none;}.cls-5{stroke:#2b7c63;stroke-width:3.65px;}.cls-5,.cls-6,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-6,.cls-8{stroke:#9ef5ee;}.cls-6{stroke-width:7px;}.cls-7{fill:#ed8936;}.cls-8{stroke-width:5.14px;}.cls-9{stroke:#fff;stroke-width:16.23px;}.cls-11{fill-rule:evenodd;}.cls-12{fill:#2b7c63;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "watermelon-pack-illustration-20");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M750.43,57.58C825.11,121.4,842,254.25,831,376.24c-10.87,122-49.52,232.89-124.2,321.06C631.87,785.67,521,851.09,426.35,834.38c-94.41-16.5-172.11-115.14-246.19-203.51C105.88,542.71,35.43,465,10.27,361.94-14.89,259.08,5.44,130.86,79.52,67.25,153.59,3.44,281.82,4,412.26,1.62S675.55-6,750.43,57.58Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 104.45,
  width: 650,
  height: 785
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 429.45,
  cy: 341.48,
  r: 232.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 430.42,
  cy: 209.85,
  r: 64.14
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M428.12,197.39c-.77-6.57-3.86-11.62-6.92-11.27s-4.93,6-4.17,12.55,3.86,11.63,6.92,11.27S428.88,204,428.12,197.39Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 208.45,
  y1: 644.48,
  x2: 650.45,
  y2: 644.48
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 327.01,
  y1: 714.48,
  x2: 531.89,
  y2: 714.48
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M419.76,296.55c-90.21,0-119.09,134.71-123.89,235.24a232.57,232.57,0,0,0,256.86,6.83C546.55,437.34,515.09,296.54,419.76,296.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M409.05,573.1a59.5,59.5,0,1,1,114.5-22.71c0,1.27,0,2.54-.12,3.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M307.57,437.26a59.5,59.5,0,0,1,22.12,114.28"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 452.26,
  cy: 406.03,
  r: 59.49
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M400.55,298.74a59.5,59.5,0,0,1-59.27,54.31c-1.42,0-2.83-.05-4.22-.14"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M336.28,473.72c5.57-31.53,14-62.43,26.29-88.37"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 429.45,
  cy: 341.48,
  r: 232.5
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M260.78,536.27A37.72,37.72,0,1,1,298.5,574,37.72,37.72,0,0,1,260.78,536.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M578.78,216.27A37.72,37.72,0,1,1,616.5,254,37.72,37.72,0,0,1,578.78,216.27Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-12",
  cx: 376.42,
  cy: 110.62,
  r: 40.11
})));

var SvgWatermelonPackIllustration20 = function SvgWatermelonPackIllustration20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 834.04 837",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-20.cc05ea20.svg";
export { ForwardRef as ReactComponent };